var assign = require('object-assign');
var moment = require('moment');

var Constants = require('../constants/Constants');
var BaseStore = require('./BaseStore');
var LocalStorage = require('../util/LocalStorage');

var UserStore = new BaseStore();
var timeout;
var lastUserId;

/**
 * Clears the UserStore
 */
UserStore.clear = function () {
    LocalStorage.clear();

    BaseStore.prototype.clear.call(this);
};

UserStore.addTimeoutListener = function (callback) {
    this.on('timeout', callback);
};
UserStore.getAvailableClients = function () {
    var data = LocalStorage.get('user');

    return data ? data.clients : [];
};
UserStore.getHmac = function () {
    var data = LocalStorage.get('user');

    return data ? data.hmac : null;
};
UserStore.getClientId = function () {
    return LocalStorage.get('active-client');
};
UserStore.getUser = function () {
    var data = LocalStorage.get('user');

    return data ? data.user : null;
};
UserStore.getCurrentRel = function () {
    const user = this.getUser()
  if (!user) {
        return null
  }
    const clientId = this.getClientId()

  return user.relationships.find(r => r.client_id === clientId)
}
UserStore.hasRole = function (role) {
    const roles = this.getCurrentRoles()

  if (Array.isArray(role)) {
    return role.some(r => roles.indexOf(r) > -1)
  }

  return roles.indexOf(role) > -1
}
UserStore.getCurrentRoles = function () {
    const rel = this.getCurrentRel()
  if (!rel || !rel.roles) {
        return []
  }

  return rel.roles
}
UserStore.hasData = function () {
    return LocalStorage.get('user') !== null;
};
UserStore.hmacNeedsRefresh = function () {
    var hmac = this.getHmac();
    var hmacExpiry = hmac ? moment(hmac.expires) : null;
    if (!hmacExpiry) {
        return false;
    }

    var diff = hmacExpiry.diff(moment());

    return diff > 0 && diff < moment.duration(10, 'minutes').asMilliseconds();
};
UserStore.initTimeout = function () {
    if (timeout) {
        clearTimeout(timeout);
    }

    var hmac = this.getHmac();
    if (hmac && hmac.expires) {
        var expiry = moment(hmac.expires);
        var ms = expiry.isAfter() ? expiry.diff(moment()) : 1000;

        timeout = setTimeout(() => {
            var newHmac = this.getHmac();

            if (newHmac && newHmac.expires && moment(newHmac.expires).isAfter(expiry)) {
                this.initTimeout();
                this.emitChange();

                return;
            }

            this.clear();
            this.emitChange();
            this.emit('timeout');
        }, ms);
    }
};
UserStore.isHmacRefreshing = function () {
    var started = moment(LocalStorage.get('refreshing-started'));
    var timeAgo = moment().diff(started);
    return timeAgo <= 10000; // Milliseconds
};
UserStore.logout = function () {
    this.setUser(null);
    LocalStorage.set('active-client', null);
};
UserStore.setActiveClientId = function (clientId) {
    LocalStorage.set('active-client', clientId);

    setTimeout(function () {
        var AppDispatcher = require('../dispatchers/AppDispatcher');

        AppDispatcher.handleRequestAction({
            actionType: Constants.store.CLEAR
        });
        this.emitChange();
    }.bind(this), 0);
};
UserStore.setHmac = function (hmac) {
    var user = LocalStorage.get('user');
    user.hmac = hmac;

    UserStore.setUser(user);
};
UserStore.setUser = function (user) {
    LocalStorage.set('user', user);
    lastUserId = user && user.user ? user.user.id : null;

    this.initTimeout();
    this.emitChange();
};
UserStore.verifyCredentials = function () {
    // Another tab has changed the localstorage.
    var user = this.getUser();

    if (user && user.id && lastUserId && user.id != lastUserId) {
        // Logged in as different users in different tabs
        setTimeout(function () {
            this.emit('credential-conflict');
        }.bind(this), 0);
    }
};
UserStore.verifyStorage = function () {
    var hmac = this.getHmac();

    if (hmac && hmac.expires && moment().isAfter(moment(hmac.expires))) {
        // Hmac expired while all tabs were closed. Tidy up.
        this.clear();
        this.emitChange();
        setTimeout(() => this.emit('retroactive-timeout'), 0);
    }

    var user = this.getUser();

    if (user) {
        lastUserId = user.id;
    }
};

UserStore.register(Constants.auth_api.GET_USER, function (payload) {
    if (payload.action.state === Constants.request.FINISHED) {
        var activeClientId = LocalStorage.get('active-client');

        if (payload.action.response.body.clients.filter(client => client.id == activeClientId).length == 0) {
            activeClientId = payload.action.response.body.clients[0].id;
        }

        LocalStorage.set('active-client', activeClientId);
        UserStore.setUser(payload.action.response.body);

        return true;
    }
});
UserStore.register(Constants.auth_api.REFRESH_HMAC, function (payload) {
    if (payload.action.state === Constants.request.PENDING) {
        LocalStorage.set('refreshing-started', moment().toISOString());
    } else {
        LocalStorage.unset('refreshing-started');
    }

    if (payload.action.state === Constants.request.FINISHED) {
        UserStore.setHmac(payload.action.response.body.hmac);

        return true;
    }
});

window.addEventListener('storage', UserStore.verifyCredentials.bind(UserStore));

UserStore.verifyStorage();
UserStore.initTimeout();

module.exports = UserStore;



// WEBPACK FOOTER //
// ./app/stores/UserStore.js